module.exports = __webpack_public_path__ + "5e8dfc4049bc535c7afd91c005dbf902.MP3";